module.exports = __webpack_public_path__ + "img/g-end.9129cb1.png";